import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getLibraryTranscriptText } from "../../services/getLibraryTranscriptText";
import "./ViewLibraryAnswer.scss";
import Renderer from "../../Components/Renderer";
import logo from "../../Assets/logo/logo.png";
import Group from "../../Assets/images/Group 616.png";
import Clock from "../../Assets/icons/clock-sm.gif";
import Layer from "../../Assets/images/Layer_x0020_1.png";
import ScrollTop from "../../Components/Buttons/ScrollTop";
import CommonForm from "../HomePage/Form/CommonForm";
import { Helmet } from "react-helmet";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import user from "../../Assets/icons/questionuser.svg";
const ViewLibraryAnswer = () => {
  const { search } = useParams();
  const [questionData, setQuestionData] = useState([]);
  const [isTranscriptVisible, setIsTranscriptVisible] = useState(false);
  const navigate = useNavigate();
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [serviceType, setServiceType] = useState("");

  const fetchData = async () => {
    const response = await getLibraryTranscriptText(search);
    if (response?.isSuccess) {
      setQuestionData(response.question);
    }
  };

  useEffect(() => {
    fetchData();
  }, [search]);

  const toggle = () => {
    setIsModelOpen(!isModelOpen);
  };

  const handlePopup = (serviceType, type, totalSteps) => {
    setIsModelOpen(true);
    setServiceType({ serviceType, type, totalSteps });
    localStorage.setItem("serviceType", serviceType);
  };

  const handlePreviousPage = () => {
    navigate(-1);
  };
  const breadCrumbData = [
    { label: "Home", path: "/" },
    { label: "Library" },
    {
      label: questionData[0]?.transcriptText
        ? `${questionData[0].transcriptText.slice(0, 50)}...`
        : "Loading...",
    },
  ];

  return (
    <>
      <Helmet>
        <title>{`${questionData[0]?.transcriptText} | Get Expert Answers and Solutions on DoubtQ`}</title>
        <meta
          name="description"
          content={`Get detailed answers and expert solutions to your questions on DoubtQ. Receive personalized guidance, explanations, and resources to help you succeed in your studies!`}
        />
        <meta
          property="og:title"
          content={`${questionData[0]?.transcriptText} - Expert Solutions | DoubtQ`}
        />
        <meta
          property="og:description"
          content={`Looking for answers? Get expert solutions to your question on DoubtQ, with step-by-step explanations and personalized guidance to help you achieve academic success!`}
        />
      </Helmet>

      <div className="container">
        <div className="row mb-3 m-0">
          <BreadCrumb items={breadCrumbData} />
        </div>
        <div className="row">
          <div
            className="back-link mb-3 text-start"
            onClick={() => handlePreviousPage()}
          >
            {`< Back to search results`}
          </div>

          <div className="col-lg-8 col-md-12 mb-4">
            <div className="question-card">
              <div className="question-heading d-flex align-items-center mb-3 ">
                <img src={user} alt="" className="me-2" />
                <h3 className="fw-bold mb-0">Question:</h3>
              </div>
              <Renderer
                content={questionData[0]?.question}
                className="renderer-content"/>
              {isTranscriptVisible && (
                <Renderer
                  content={questionData[0]?.transcriptText}
                  className="mt-3 renderer-content"
                />
              )}
            </div>

            {questionData[0]?.answer && (
              <div className="answer-card mt-4">
                <div className="answer-heading d-flex align-items-center mb-3">
                  <img src={user} alt="" className="me-2" />
                  <h3 className="fw-bold mb-2">Answer:</h3>
                </div>
                <div className="answer-sesction">
                  <Renderer content={questionData[0]?.answer} />
                </div>
              </div>
            )}

<div className="row">
  <div className="col-12">
    <div className="question-help-banner">

      <div className="row align-items-center">

        <div className="col-6 col-md-1 order-1 help-banner-icon">
          <img src={Layer} alt="Layer Icon" className="img-fluid" />
        </div>

        <div className="col-6 col-md-1 d-flex justify-content-end order-2 order-md-4 help-banner-clock">
          <img src={Clock} alt="Clock Icon" width="40" className="img-fluid" />
        </div>

        <div className="col-12 col-md-5 mt-2 mt-md-0 order-3 order-md-2 help-banner-text">
          <p>Our expert will answer within 20 minutes!</p>
        </div>

        <div className="col-12 col-md-5 mt-2 mt-md-0 d-flex justify-content-md-end order-4 order-md-3 help-banner-action">
          <button
            className="do-my-ass que"
            onClick={() => {
              handlePopup("HomeworkHelp", "mcqHelp", 3);
            }}
          >
            Ask a Question
          </button>
        </div>

      </div>

    </div>
  </div>
</div>


          </div>

          <div className="col-lg-4 col-md-12 mb-4">
            <div className="search-sidebar" style={{marginRight:0}}>
              <div className="logo mb-3">
                <img src={logo} alt="logo" className="img-fluid" />
              </div>
              <p className="side-head mb-3">
                NEVER PAY EXTRA FOR YOUR ASSIGNMENTS
              </p>
              <img src={Group} alt="24/7 support" className="img-fluid mb-3" />
              <div className="side-help mb-3">
                <span>
                  ARE YOU <span className="looking">LOOKING</span> FOR{" "}
                </span>
                <br />
                <span>
                  ASSIGNMENT <span className="help">HELP?</span>
                </span>
              </div>

              <div className="ass-button">
                <button className="do-my-ass" onClick={() => navigate("/")}>
                  Do my Assignment
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isModelOpen ? (
        <CommonForm
          isOpen={isModelOpen}
          toggle={toggle}
          typeData={serviceType}
          question={questionData[0]?.question}
        />
      ) : (
        <></>
      )}
      <ScrollTop />
      {/* <GetPopup /> */}
    </>
  );
};

export default ViewLibraryAnswer;
